import {
  FX_RATES_CORRECT_PERMISSION,
  FX_RATES_REGISTER_PERMISSION,
} from '@/core/config/auth-permissions.config';
import type { DrawerRouteDef } from '@/core/drawer-route.util';

/**
 * The `data.drawer` id of the FX register (create) drawer — the URL
 * `/fx-rates/new` (`DESIGN-WUIAM-135` §1.2 row 16 / §2.2).
 *
 * ONE owner for the id: `app.routes.ts` generates the child records from
 * {@link FX_RATES_DRAWER_DEFS} and the screen's dispatch effect compares
 * `data.drawer` against these constants, so the route table and the screen can
 * never disagree about what a URL names.
 */
export const FX_RATE_DRAWER_REGISTER = 'register';

/** The `data.drawer` id of the FX correct drawer — `/fx-rates/:fxRateId/correct`. */
export const FX_RATE_DRAWER_CORRECT = 'correct';

/**
 * The FX Rates screen's deep-link drawer inventory (DAG node (c)).
 *
 * Both drawers are FORM-bearing (a dirty draft must not be discarded
 * silently), so both carry the veto. The permissions are the SAME constants
 * the screen's own `canRegister` / row menu gate on — referenced, never
 * copied, so the route guard and the affordance cannot drift.
 *
 * Deliberately DI-FREE data: `app.routes.ts` is evaluated at module load and
 * cannot build anything that needs injected services. The `:id` path parameter
 * is the reserved name the shared `activeDrawer` helper reads (the URL segment
 * itself is simply the `fx_rate_id`, e.g. `/fx-rates/fxr-0001-…/correct`).
 */
export const FX_RATES_DRAWER_DEFS: readonly DrawerRouteDef[] = [
  {
    path: 'new',
    drawer: FX_RATE_DRAWER_REGISTER,
    permission: FX_RATES_REGISTER_PERMISSION,
    veto: true,
  },
  {
    path: ':id/correct',
    drawer: FX_RATE_DRAWER_CORRECT,
    permission: FX_RATES_CORRECT_PERMISSION,
    veto: true,
  },
];
